import React, { Component } from 'react';
import Heart from '../../images/heart.svg'

class FooterLinks extends Component {
	render() {
		return (
			<div className="footer-links">
				<div className="links">
					<ul>
						<li><a target="_blank" rel="noopener noreferrer" href={`${this.props.stringData.string_27}`}>{this.props.stringData.string_15}</a></li>
						<li><a target="_blank" rel="noopener noreferrer" href="https://vantale.de/pages/privacy-datenschutz">{this.props.stringData.string_16}</a></li>
						<li><a target="_blank" rel="noopener noreferrer" href="https://vantale.de/pages/imprint-vantale">{this.props.stringData.string_17}</a></li>
						<li><a target="_blank" rel="noopener noreferrer" href={`${this.props.stringData.string_28}`}>{this.props.stringData.string_18}</a></li>
						<li><a target="_blank" rel="noopener noreferrer" href={`${this.props.stringData.string_30}`}>{this.props.stringData.string_19}</a></li>
						<li><a target="_blank" rel="noopener noreferrer" href={`${this.props.stringData.string_32}`}>{this.props.stringData.string_31}</a></li>
					</ul>
				</div>

				<div className="credits">
					{ this.props.activeLanguage === 'english' &&
						<a rel="noopener noreferrer" target="_blank" href="https://vantale.de/pages/the-rygg-made-with-love">
							Utensilo made with <img src={Heart} alt="Love"/>
						</a>
					}

					{this.props.activeLanguage === 'german' &&
						<a rel="noopener noreferrer" target="_blank" href="https://vantale.de/pages/the-rygg-made-with-love">
							Das Utensilo, mit <img src={Heart} alt="Love"/> gemacht
						</a>	
					}
				</div>
			</div>
		)
	}
}
export default FooterLinks;